export const blockIconsHomeToolsPliersWireStripperNew = (
	<span className='material-symbols-outlined'>tools_pliers_wire_stripper</span>
);
